module.exports = __webpack_public_path__ + "img/other-icon-img8.eb28cda4.svg";